import type { MeProfile } from '@/api/services/me';
import { canViewPlatformActivity, canViewWorkspaceActivity } from '@/utils/navCapabilities';

/** Full activity page path for dashboard "View all" links. */
export function activityViewAllPath(
  me: MeProfile | null | undefined,
  searchId?: string,
): string {
  const base = canViewWorkspaceActivity(me)
    ? '/customer-activity'
    : canViewPlatformActivity(me)
      ? '/activity'
      : '/customer-activity';
  if (!searchId) return base;
  const params = new URLSearchParams({ search_id: searchId });
  return `${base}?${params.toString()}`;
}
